import styles from './ReactSelectLabel.module.css';
import React, { ReactNode } from 'react';
import cn from 'classnames';

type ReactSelectLabelProps = { children: ReactNode | ReactNode[]; size?: 'big' | 'little' };

export function ReactSelectLabel({ children, size = 'big' }: ReactSelectLabelProps) {
    return <div className={cn(styles.reactSelectLabel, `size-${size}`)}>{children}</div>;
}
